import React, { useState } from "react";
import "../style.scss";
import PlanIcon from "../../../../../../icons/PlanIcon";
import PlanPointIcon from "../../../../../../icons/PlanPointIcon";
import { upgradeSubscription } from "../../../../../data/redux/pricing/_pricingAction";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const MonthlyTab = ({ plans }: any) => {
  const dispatch: any = useDispatch();
  const [loadingStates, setLoadingStates] = useState<any>({});
  const [errorStates, setErrorStates] = useState<any>({}); // Initialize as empty object

  const handleUpgradePlan = async (plan_uuid: string, platform: string) => {
    if (platform === "ios") {
      toast.error("This subscription was purchased via in-app purchase. Please cancel it through the app store.");
      return;
    }
    if (!plan_uuid) {
      setErrorStates((prev: any) => ({
        ...prev,
        [plan_uuid || "unknown"]: "Invalid plan UUID",
      }));
      return;
    }

    setLoadingStates((prev: any) => ({ ...prev, [plan_uuid]: true }));
    setErrorStates((prev: any) => ({ ...prev, [plan_uuid]: null }));

    try {
      const response = await dispatch(upgradeSubscription());

      if (response?.payload?.url) {
        // Redirect to the Stripe checkout URL
        window.location.href = response?.payload?.url;
      }
      else {
        setErrorStates((prev: any) => ({
          ...prev,
          [plan_uuid]: response?.payload?.message || "Failed to upgrade plan",
        }));
      }
    } catch (err: any) {
      setErrorStates((prev: any) => ({
        ...prev,
        [plan_uuid]: err.response?.payload?.message || "An error occurred",
      }));
    } finally {
      setLoadingStates((prev: any) => ({ ...prev, [plan_uuid]: false }));
    }
  };

  return (
    <div className="container">
      <div className="row d-flex align-items-stretch">
        {plans.map((plan: any) => (
          <div key={plan?.id} className="col-12 col-sm-12 col-md-12 col-lg-4 mb-3">
            <div
              // className={`planWrapper h-100 d-flex justify-content-between flex-column ${plan?.plan_name === "Professional" ? "professionalPlan text-white" : ""
              //   }`}
              className={`planWrapper h-100 d-flex justify-content-between flex-column ${plan?.is_purchased ? "professionalPlan text-white" : ""}`}
            >
              <div>
                <div className="upper text-center">
                  {plan?.is_purchased && (
                    <div className="best-value-image selectedPlan">
                      <div className="best-value-inner">
                        <div className="best-value-inner-2">
                          <img src="../assets/img/best-value-image.png" alt="best-value" />
                          <p>Current plan</p>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="svgIcon mb-3">
                    <PlanIcon plan_name={plan?.plan_name} />
                  </div>
                  <h4 className="planName">{plan?.plan_name}</h4>
                  <label className="planPrice">
                    ${plan?.price}/<span>month</span>
                  </label>
                  <p>Billed {plan?.type === "monthly" ? "monthly" : "annually"}.</p>
                </div>
                <ul className="listtype">
                  {plan?.features.map((feature: any, index: any) => (
                    <li key={index}>
                      <PlanPointIcon />
                      {feature.includes(" – ") ? (
                        <>
                          <strong>{feature.split(" – ")[0]} –</strong> {feature.split(" – ")[1]}
                        </>
                      ) : (
                        feature
                      )}
                    </li>
                  ))}
                </ul>
              </div>
              <button
                className="primaryButton text-white rounded-circle w-100"
                onClick={() => handleUpgradePlan(plan?.uuid, plan?.platform)}
                disabled={loadingStates[plan?.uuid] || plan?.is_purchased}
              >
                {loadingStates[plan?.uuid] ? "Processing..." : plan?.is_purchased ? "Active Plan" : "Upgrade Plan"}
              </button>
              {errorStates[plan?.uuid] && (
                <p className="text-danger mt-2">{errorStates[plan?.uuid]}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MonthlyTab;